export const endpoints = {
    test: `https://dkfj70hbdg.execute-api.us-east-1.amazonaws.com/test/v0/rest`,
    acceptance: `https://wgedirszxb.execute-api.us-east-1.amazonaws.com/acceptance/v0/rest`,
    prod: `https://5jwe7rofob.execute-api.us-east-1.amazonaws.com/prod/v0/rest`,
};
